import React, { useState, useEffect } from 'react';
import { Modal, Upload, message, Select, Button, Icon, Typography, Row, Col } from 'antd';
import { platformApi } from '../../../../api';
import { ENDPOINT } from '../../../../constants';

const { Text } = Typography;

const getFullUrl = (filePath) => {
  if (!filePath) return '';
  if (filePath.startsWith('http://') || filePath.startsWith('https://')) return filePath;
  const cleanEndpoint = ENDPOINT.endsWith('/') ? ENDPOINT.slice(0, -1) : ENDPOINT;
  const cleanPath = filePath.startsWith('/') ? filePath : `/${filePath}`;
  return `${cleanEndpoint}${cleanPath}`;
};

export default function ImportExportData(props) {
  const { open, close, upload, exportFile: initialExportFile, createAccess } = props;
  const [templateLink, setTemplateLink] = useState('');
  const [exportLoading, setExportLoading] = useState(false);

  useEffect(() => {
    if (open) {
      platformApi
        .get('/api/jobCode/template')
        .then(res => {
          let { data } = res;
          if (data.code === 200 && data.response) {
            setTemplateLink(getFullUrl(data.response));
          }
        })
        .catch(err => console.error("Error fetching jobCode template:", err));
    }
  }, [open]);

  const beforeDocUpload = file => {
    const isLt2M = file.size / 1024 / 1024 < 50;
    if (!isLt2M) {
      message.error("Document must smaller than 50MB!");
    }
    return isLt2M;
  };

  const handleExportClick = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (exportLoading) return;

    setExportLoading(true);
    const hideLoading = message.loading("Generating Excel sheet, please wait...", 0);

    platformApi
      .get("/api/jobCode/data/export")
      .then((res) => {
        hideLoading();
        setExportLoading(false);
        const { data } = res;
        if (data.code === 200 && data.response) {
          message.success("Excel sheet generated successfully!");
          const fullUrl = getFullUrl(data.response);
          window.open(fullUrl, "_blank");
        } else {
          message.error("Failed to generate Excel sheet.");
        }
      })
      .catch((err) => {
        hideLoading();
        setExportLoading(false);
        message.error("Error generating Excel sheet.");
        console.error("Export error:", err);
      });
  };

  const handleTemplateClick = (e) => {
    e.stopPropagation();
    if (!templateLink) {
      e.preventDefault();
      message.warning("Template file is not ready yet. Please try again in a moment.");
      return;
    }
    window.open(getFullUrl(templateLink), "_blank");
  };

  return (
    <Modal
      title="Import / Export Data"
      visible={open}
      onCancel={() => {
        close();
      }}
      okButtonProps={{ style: { display: 'none' } }}
    >
      <Row type="flex" justify="space-between">
        <Col span={12}>
          <Upload
            beforeUpload={e => beforeDocUpload(e)}
            onChange={event => upload(event)}
            action={`${ENDPOINT}/api/upload/mocky`}
            accept=".xlsx"
          >
            <Button type="primary">
              <Icon type="upload" />
              <Text style={{ color: 'white' }}>Import Data</Text>
            </Button>
          </Upload>
        </Col>
        <Col span={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            type="primary"
            loading={exportLoading}
            onClick={handleExportClick}
            icon={!exportLoading ? <Icon type="download" /> : null}
          >
            <Text style={{ color: 'white' }}>Export Data</Text>
          </Button>
        </Col>
      </Row>
      <div style={{ marginTop: '8%' }}>
        <a href={templateLink ? getFullUrl(templateLink) : '#'} target="_blank" download onClick={handleTemplateClick} className="linkylink" rel="noreferrer">Download Template Here for Job Code</a>
      </div>
    </Modal>
  );
}
